import './show.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Wiki from 'src/entities/Wiki';

import { destroyWiki, readWikisByGroup } from '../../actions/wiki';
import TrashbinGreenLight from '../../res/img/trashbin_green_light.svg';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  account: Member;
  group: Group;
  wiki: Wiki;
  readWikisByGroup: (group: Group) => void;
  destroyWiki: (wiki: Wiki) => void;
}

interface IState {
  apiLoaded: boolean;
  deleted: boolean;
}

class ShowComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      apiLoaded: false,
      deleted: false
    };
  }

  componentDidUpdate() {
    if (this.props.group !== undefined && !this.state.apiLoaded) {
      this.props.readWikisByGroup(this.props.group);
      this.setState({
        apiLoaded: true
      });
    }
  }

  render() {
    if (this.props.group === undefined || this.props.wiki === undefined) {
      return null;
    }

    if (this.state.deleted) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.group.title + '/wikis',
            state: { from: location.pathname }
          }}
        />
      );
    }

    return (
      <div id="WikiShow">
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="wiki" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>

        <div id="Header">
          <div id="Title">{this.props.wiki.title}</div>
          <div id="Destroy">
            <img
              onMouseUp={this.destroyWiki.bind(this, this.props.wiki)}
              onTouchEnd={this.destroyWiki.bind(this, this.props.wiki)}
              src={TrashbinGreenLight}
            />
          </div>
        </div>

        <div id="Text">{Utility.nl2br(this.props.wiki.text)}</div>
        <div id="Action">
          {this.props.group.admins.includes(this.props.account.id) ? (
            <Link
              to={
                '/' +
                this.props.group.title +
                '/wiki/' +
                this.props.wiki.id +
                '/update'
              }
            >
              <span>編集する</span>
            </Link>
          ) : null}

          {/* <Link
            to={
              "/" +
              this.props.group.title +
              "/wiki/" +
              this.props.wiki.id +
              "/history"
            }
          >
            <span>更新履歴を見る</span>
          </Link> */}
        </div>
      </div>
    );
  }

  destroyWiki(wiki: Wiki) {
    if (confirm('削除します')) {
      this.props.destroyWiki(wiki);
      this.setState({
        deleted: true
      });
    }
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  wiki: state.Wiki.find(
    (wiki: Wiki) => wiki.id === Number(ownProps.match.params.wikiId)
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readWikisByGroup(group: Group) {
      dispatch(readWikisByGroup(group));
    },
    destroyWiki(wiki: Wiki) {
      dispatch(destroyWiki(wiki));
    }
  };
};

const Show = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowComponent);

export default Show;



// WEBPACK FOOTER //
// ./src/components/Wiki/show.tsx